/*
 * @Author: zhaoyu zhaoyu17@lenovo.com
 * @Date: 2022-09-15 13:26:07
 * @LastEditors: zhaoyu zhaoyu17@lenovo.com
 * @LastEditTime: 2022-09-24 16:55:43
 * @FilePath: /pscd-portal-www/packages/www/src/plugins/extension/link.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const EnumWorkbench = {
    /** 工作台首页 */
    workbench: `/workbench/`,
};
